import React from 'react';
import { Helmet } from 'react-helmet';

function NRIMatrimonials() {
    const testimonials = [
        {
            name: 'Sumathi',
            location: 'London, UK',
            quote: "I wasted a lot of time looking for a partner on other sites and finally found VivahMilap. Within 2 months, I found my perfect match! I wish I had seen this site long back. The profiles are genuine, verified, and the UK NRI community is amazing.",
            initials: 'SM',
            rating: 5,
            plan: 'Gold Premium',
            timeToMatch: '2 months'
        },
        {
            name: 'Rahul & Priya',
            location: 'Manchester, UK',
            quote: "As a UK-based Indian, finding someone who understood both cultures was tough. VivahMilap's NRI focus made all the difference. We matched in 3 months and got engaged! Highly recommend for Indian professionals in the UK.",
            initials: 'RP',
            rating: 5,
            plan: 'Platinum',
            timeToMatch: '3 months'
        },
        {
            name: 'Dr. Anjali Mehta',
            location: 'Birmingham, UK',
            quote: "I'm a doctor in the NHS and couldn't find serious matches on regular dating apps. VivahMilap's matrimony focus and horoscope matching helped me find my soulmate. The personal matchmaker service was exceptional!",
            initials: 'AM',
            rating: 5,
            plan: 'Elite',
            timeToMatch: '4 months'
        },
        {
            name: 'Arjun Singh',
            location: 'Edinburgh, UK',
            quote: "Parents were worried about finding a suitable match for me in the UK. VivahMilap's 'Profile Created By Parents' feature gave them peace of mind. Found my wife through the platform within 5 months!",
            initials: 'AS',
            rating: 5,
            plan: 'Gold',
            timeToMatch: '5 months'
        },
        {
            name: 'Kavya Reddy',
            location: 'London, UK',
            quote: "Best matrimony site for NRIs in UK! The advanced filters helped me find someone with matching values, caste, and career goals. The verification process ensured genuine profiles. Thank you VivahMilap!",
            initials: 'KR',
            rating: 5,
            plan: 'Gold',
            timeToMatch: '3 months'
        }
    ];

    return (
        <>
            {/* --- SEO Metadata --- */}
            <Helmet>
                <title>NRI Matrimonials UK | Find an Indian Life Partner</title>
                <meta
                    name="description"
                    content="Find Indian brides and grooms across the UK on VivahMilap, the NRI matrimony site for Hindu, Muslim, Sikh and Christian families. Free registration."
                />
                <meta
                    name="keywords"
                    content="NRI matrimonials UK, Indian matrimonial UK, UK Indian brides, UK Indian grooms, NRI matrimony London, Indian marriage UK, Hindu matrimony UK, Muslim matrimony UK, Sikh matrimony UK, Brahmin matrimony UK, British Indian marriage, Indian partner UK, vivahmilap UK, matrimony site for Indians in UK, find Indian life partner in UK"
                />
                <link rel="canonical" href="https://indianflatmates.co.uk/nri-matrimonials-uk" />

                {/* Open Graph */}
                <meta property="og:title" content="NRI Matrimonials UK | Find an Indian Life Partner" />
                <meta property="og:description" content="Find Indian brides and grooms across the UK on VivahMilap, the NRI matrimony site for Hindu, Muslim, Sikh and Christian families. Free registration." />
                <meta name="twitter:title" content="NRI Matrimonials UK | Find an Indian Life Partner" />
                <meta name="twitter:description" content="Find Indian brides and grooms across the UK on VivahMilap, the NRI matrimony site for Hindu, Muslim, Sikh and Christian families. Free registration." />
                <meta property="og:type" content="article" />
                <meta property="og:url" content="https://indianflatmates.co.uk/nri-matrimonials-uk" />

                {/* Structured Data - FAQ (must match the visible FAQ section below) */}
                <script type="application/ld+json">{`
                    {
                      "@context": "https://schema.org",
                      "@type": "FAQPage",
                      "mainEntity": [
                        {
                          "@type": "Question",
                          "name": "What is the best matrimony site for NRIs in UK?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "VivahMilap.com is the leading matrimony platform specifically designed for NRI Indians in UK. It offers verified profiles, horoscope matching, advanced filters, and personal matchmaker services."
                          }
                        },
                        {
                          "@type": "Question",
                          "name": "How can I find an Indian life partner in UK?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Register for free on VivahMilap.com. Create your profile, set your preferences (age, religion, caste, location), and browse thousands of verified UK-based Indian profiles. Premium features unlock contact details and unlimited messaging."
                          }
                        },
                        {
                          "@type": "Question",
                          "name": "Is VivahMilap free for UK users?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Yes! Free registration and browsing. Premium plans available in GBP: Silver (£29), Gold (£59 - most popular), Platinum (£129), Elite (£499)."
                          }
                        },
                        {
                          "@type": "Question",
                          "name": "Does VivahMilap offer horoscope matching?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Yes, Gold and higher plans include 36 Guna Milan horoscope matching, Manglik compatibility, Gotra exclusion, and Kundali analysis - essential for traditional Indian families."
                          }
                        }
                      ]
                    }
                `}</script>
            </Helmet>

            <div className="container mx-auto p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md my-6">
                <div className="max-w-4xl mx-auto text-left">

                    {/* Header */}
                    <h1 className="text-3xl md:text-4xl font-extrabold text-indigo-700 dark:text-indigo-300 mb-4">
                        💍 NRI Matrimonials UK - Find Your Perfect Indian Life Partner
                    </h1>
                    <p className="text-lg text-gray-600 dark:text-gray-300 mb-6">
                        Connecting UK-based Indian professionals and their families with verified matrimonial profiles across the UK, India, USA, Canada, and Australia.
                    </p>

                    {/* Featured CTA to VivahMilap */}
                    <div className="bg-gradient-to-r from-yellow-500 to-orange-500 text-white p-8 rounded-xl shadow-lg mb-10 text-center">
                        <h2 className="text-2xl md:text-3xl font-bold mb-3">🌟 Trusted Partner: VivahMilap.com</h2>
                        <p className="text-lg mb-4">India's #1 Matrimonial Platform for NRIs in UK</p>
                        <div className="flex flex-wrap justify-center gap-6 mb-6 text-sm">
                            <div>✓ 50,000+ verified profiles</div>
                            <div>✓ 12,500+ success stories</div>
                            <div>✓ 92% match success rate</div>
                            <div>✓ Horoscope matching</div>
                        </div>
                        <a
                            href="https://vivahmilap.com"
                            target="_blank"
                            rel="noreferrer"
                            className="inline-block bg-white text-indigo-700 font-bold px-8 py-3 rounded-lg hover:bg-gray-100 transition shadow-lg text-lg"
                        >
                            Register Free on VivahMilap →
                        </a>
                        <p className="text-xs mt-3 text-white/90">Free registration • 30-day money-back guarantee • GBP & INR pricing</p>
                    </div>

                    {/* Why UK NRIs Choose VivahMilap */}
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white mb-4 mt-8">
                        Why UK NRIs Choose VivahMilap for Matrimony
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                        <div className="bg-indigo-50 dark:bg-gray-700 p-5 rounded-lg">
                            <h3 className="font-bold text-lg text-indigo-700 dark:text-indigo-300 mb-2">🇬🇧 UK-Focused NRI Community</h3>
                            <p className="text-gray-700 dark:text-gray-300 text-sm">
                                Largest database of Indian professionals living in London, Manchester, Birmingham, Edinburgh, Leeds, and across UK. Connect with doctors, engineers, IT professionals, and business owners.
                            </p>
                        </div>
                        <div className="bg-indigo-50 dark:bg-gray-700 p-5 rounded-lg">
                            <h3 className="font-bold text-lg text-indigo-700 dark:text-indigo-300 mb-2">🕉️ Traditional Matchmaking</h3>
                            <p className="text-gray-700 dark:text-gray-300 text-sm">
                                36 Guna Milan horoscope matching, Gotra exclusion (same gotra prevention), Manglik matching, and Kundali analysis - all included in Gold plan. Respect for traditions.
                            </p>
                        </div>
                        <div className="bg-indigo-50 dark:bg-gray-700 p-5 rounded-lg">
                            <h3 className="font-bold text-lg text-indigo-700 dark:text-indigo-300 mb-2">👨‍👩‍👧 Parent-Friendly</h3>
                            <p className="text-gray-700 dark:text-gray-300 text-sm">
                                "Profile created by parents" feature for traditional families. Parents can search and contact on behalf of their children - perfect for arranged marriage culture.
                            </p>
                        </div>
                        <div className="bg-indigo-50 dark:bg-gray-700 p-5 rounded-lg">
                            <h3 className="font-bold text-lg text-indigo-700 dark:text-indigo-300 mb-2">💷 GBP Pricing for UK</h3>
                            <p className="text-gray-700 dark:text-gray-300 text-sm">
                                Pay in Pounds Sterling via UK debit/credit cards or PayPal. Plans start from £29 (Silver) to £799 (Elite). 30-day money-back guarantee on all plans.
                            </p>
                        </div>
                        <div className="bg-indigo-50 dark:bg-gray-700 p-5 rounded-lg">
                            <h3 className="font-bold text-lg text-indigo-700 dark:text-indigo-300 mb-2">🔒 100% Verified Profiles</h3>
                            <p className="text-gray-700 dark:text-gray-300 text-sm">
                                Mobile verified, email verified, document verified, and photo verified. No fake profiles - only genuine people looking for serious matrimonial relationships.
                            </p>
                        </div>
                        <div className="bg-indigo-50 dark:bg-gray-700 p-5 rounded-lg">
                            <h3 className="font-bold text-lg text-indigo-700 dark:text-indigo-300 mb-2">👑 Personal Matchmaker</h3>
                            <p className="text-gray-700 dark:text-gray-300 text-sm">
                                Platinum and Elite members get a dedicated matchmaker who personally curates matches, schedules introductions, and guides you through the process - just like a traditional family matchmaker.
                            </p>
                        </div>
                    </div>

                    {/* Testimonials */}
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white mb-4 mt-8">
                        💑 Real Success Stories from UK NRIs
                    </h2>
                    <p className="text-gray-600 dark:text-gray-300 mb-6">
                        Thousands of Indian NRIs in UK have found their perfect life partner through VivahMilap. Here are some of their stories:
                    </p>

                    <div className="space-y-6 mb-10">
                        {testimonials.map((t, idx) => (
                            <div key={idx} className="bg-gradient-to-r from-pink-50 to-orange-50 dark:from-gray-700 dark:to-gray-700 p-6 rounded-xl border-2 border-pink-200 dark:border-gray-600 shadow-md">
                                <div className="flex items-start gap-4 mb-3">
                                    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-indigo-500 to-pink-500 text-white flex items-center justify-center text-lg font-bold flex-shrink-0">
                                        {t.initials}
                                    </div>
                                    <div className="flex-1">
                                        <h4 className="font-bold text-lg text-gray-800 dark:text-white">{t.name}</h4>
                                        <p className="text-sm text-gray-500 dark:text-gray-400">📍 {t.location}</p>
                                        <div className="flex gap-1 text-yellow-500 text-sm mt-1">
                                            {'★'.repeat(t.rating)}
                                        </div>
                                    </div>
                                </div>
                                <p className="text-gray-700 dark:text-gray-300 italic mb-3">"{t.quote}"</p>
                                <div className="flex flex-wrap gap-3 text-xs">
                                    <span className="bg-indigo-100 dark:bg-indigo-900 text-indigo-700 dark:text-indigo-300 px-3 py-1 rounded-full font-semibold">
                                        {t.plan} Plan
                                    </span>
                                    <span className="bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300 px-3 py-1 rounded-full font-semibold">
                                        ⏱️ Found match in {t.timeToMatch}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Regional Focus */}
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white mb-4 mt-8">
                        🌆 Popular UK Cities for NRI Matrimony
                    </h2>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8">
                        {['London', 'Manchester', 'Birmingham', 'Edinburgh', 'Leeds', 'Glasgow', 'Bristol', 'Liverpool', 'Leicester', 'Coventry', 'Cardiff', 'Newcastle'].map(city => (
                            <a
                                key={city}
                                href={`https://vivahmilap.com/matrimony/${city.toLowerCase()}`}
                                target="_blank"
                                rel="noreferrer"
                                className="bg-white dark:bg-gray-700 border border-indigo-200 dark:border-gray-600 p-3 rounded-lg text-center hover:bg-indigo-50 dark:hover:bg-gray-600 transition"
                            >
                                <div className="font-semibold text-indigo-700 dark:text-indigo-300">{city}</div>
                                <div className="text-xs text-gray-500 dark:text-gray-400">Matrimony Matches</div>
                            </a>
                        ))}
                    </div>

                    {/* Communities */}
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white mb-4 mt-8">
                        🎯 Find Partner by Community & Religion
                    </h2>
                    <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-8">
                        {[
                            { name: 'Hindu', url: 'hindu' },
                            { name: 'Muslim', url: 'muslim' },
                            { name: 'Sikh', url: 'sikh' },
                            { name: 'Christian', url: 'christian' },
                            { name: 'Jain', url: 'jain' },
                            { name: 'Brahmin', url: 'brahmin' },
                            { name: 'Rajput', url: 'rajput' },
                            { name: 'Jat', url: 'jat' },
                            { name: 'Marwari', url: 'marwari' },
                            { name: 'NRI', url: 'nri' }
                        ].map(item => (
                            <a
                                key={item.url}
                                href={`https://vivahmilap.com/matrimony/${item.url}`}
                                target="_blank"
                                rel="noreferrer"
                                className="bg-gradient-to-br from-indigo-50 to-purple-50 dark:from-gray-700 dark:to-gray-700 border border-indigo-200 dark:border-gray-600 p-3 rounded-lg text-center hover:shadow-lg transition"
                            >
                                <div className="font-semibold text-indigo-700 dark:text-indigo-300 text-sm">{item.name}</div>
                                <div className="text-xs text-gray-500 dark:text-gray-400">Matrimony</div>
                            </a>
                        ))}
                    </div>

                    {/* FAQ Section */}
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white mb-4 mt-8">
                        ❓ Frequently Asked Questions
                    </h2>
                    <div className="space-y-4 mb-10">
                        <div className="bg-gray-50 dark:bg-gray-700 p-5 rounded-lg">
                            <h3 className="font-bold text-lg text-gray-800 dark:text-white mb-2">
                                Q: What is the best matrimony site for NRIs in UK?
                            </h3>
                            <p className="text-gray-700 dark:text-gray-300">
                                <strong><a href="https://vivahmilap.com" target="_blank" rel="noreferrer" className="text-indigo-600 hover:underline">VivahMilap.com</a></strong> is the leading matrimony platform specifically designed for NRI Indians in UK. It offers verified profiles, horoscope matching, advanced filters, and personal matchmaker services.
                            </p>
                        </div>
                        <div className="bg-gray-50 dark:bg-gray-700 p-5 rounded-lg">
                            <h3 className="font-bold text-lg text-gray-800 dark:text-white mb-2">
                                Q: How can I find an Indian life partner in UK?
                            </h3>
                            <p className="text-gray-700 dark:text-gray-300">
                                Register for free on <a href="https://vivahmilap.com/register" target="_blank" rel="noreferrer" className="text-indigo-600 hover:underline">VivahMilap.com</a>. Create your profile, set your preferences (age, religion, caste, location), and browse thousands of verified UK-based Indian profiles. Premium features unlock contact details and unlimited messaging.
                            </p>
                        </div>
                        <div className="bg-gray-50 dark:bg-gray-700 p-5 rounded-lg">
                            <h3 className="font-bold text-lg text-gray-800 dark:text-white mb-2">
                                Q: Is VivahMilap free for UK users?
                            </h3>
                            <p className="text-gray-700 dark:text-gray-300">
                                Yes! Free registration and browsing. Premium plans available in GBP: Silver (£29), Gold (£59 - most popular), Platinum (£129), Elite (£499).
                            </p>
                        </div>
                        <div className="bg-gray-50 dark:bg-gray-700 p-5 rounded-lg">
                            <h3 className="font-bold text-lg text-gray-800 dark:text-white mb-2">
                                Q: Does VivahMilap offer horoscope matching?
                            </h3>
                            <p className="text-gray-700 dark:text-gray-300">
                                Yes, Gold and higher plans include 36 Guna Milan horoscope matching, Manglik compatibility, Gotra exclusion, and Kundali analysis - essential for traditional Indian families.
                            </p>
                        </div>
                    </div>

                    {/* Final CTA */}
                    <div className="bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600 text-white p-8 rounded-xl shadow-2xl text-center mb-8">
                        <h2 className="text-3xl md:text-4xl font-bold mb-3">Ready to Find Your Life Partner? 💕</h2>
                        <p className="text-lg mb-6">Join 50,000+ UK NRIs who found love on VivahMilap</p>
                        <div className="flex flex-wrap justify-center gap-4">
                            <a
                                href="https://vivahmilap.com/register"
                                target="_blank"
                                rel="noreferrer"
                                className="bg-white text-indigo-700 font-bold px-8 py-3 rounded-lg hover:bg-gray-100 transition text-lg shadow-lg"
                            >
                                Register Free Now →
                            </a>
                            <a
                                href="https://vivahmilap.com/browse"
                                target="_blank"
                                rel="noreferrer"
                                className="bg-pink-500 text-white font-bold px-8 py-3 rounded-lg hover:bg-pink-600 transition text-lg shadow-lg"
                            >
                                Browse Profiles →
                            </a>
                        </div>
                        <p className="text-sm mt-4 text-white/90">
                            🌟 Trusted by 12,500+ couples • ✓ 100% verified profiles • 💷 GBP pricing • 🔒 Privacy-first
                        </p>
                    </div>

                    {/* Related Services */}
                    <div className="border-t border-gray-200 dark:border-gray-700 pt-6">
                        <h3 className="font-bold text-gray-700 dark:text-gray-300 mb-3">Related Services for UK NRIs:</h3>
                        <div className="flex flex-wrap gap-2">
                            <a href="/visa-and-immigration-support" className="text-sm bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 px-3 py-1 rounded hover:bg-indigo-100 dark:hover:bg-indigo-900 transition">Visa & Immigration</a>
                            <a href="/mortgages-for-indians" className="text-sm bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 px-3 py-1 rounded hover:bg-indigo-100 dark:hover:bg-indigo-900 transition">UK Mortgages</a>
                            <a href="/money-transfer-to-india" className="text-sm bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 px-3 py-1 rounded hover:bg-indigo-100 dark:hover:bg-indigo-900 transition">Money Transfer</a>
                            <a href="/uk-jobs-for-indians" className="text-sm bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 px-3 py-1 rounded hover:bg-indigo-100 dark:hover:bg-indigo-900 transition">UK Jobs</a>
                            <a href="/indian-events-and-festivals" className="text-sm bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 px-3 py-1 rounded hover:bg-indigo-100 dark:hover:bg-indigo-900 transition">Indian Events</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default NRIMatrimonials;
